// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3pFUu","title":"FrontImage_title__2N6Wl"};